import { useRouteMatch } from 'react-router-dom';

import routeFactory from '../../../common/util/routeFactory';
import { DatalabScreens } from '../constants';

/**
 * Type guard to check if a string is a valid DatalabScreens value
 * @param screen - The screen value to check
 * @returns True if the value is a valid DatalabScreens enum value
 */
export function isDatalabScreen(screen: string): screen is DatalabScreens {
  return Object.values(DatalabScreens).includes(screen as DatalabScreens);
}

/**
 * Hook to get the current datalab screen from the URL parameters
 * @returns The current datalab screen or null if none is found
 */
export const useCurrentDatalabScreen = (): DatalabScreens | null => {
  const match = useRouteMatch<{
    datalabScreen?: string;
  }>(routeFactory.datalab.routePath);

  if (!match) {
    return null;
  }

  const datalabScreen = match.params.datalabScreen ?? '';

  return isDatalabScreen(datalabScreen) ? datalabScreen : null;
};
